import { useQuery } from 'react-query'
import { api } from '../../api'
import { localConfig } from '../../../Configs/localConfig'
import { errorAlert } from '../../../utils/alert'

export type ItensConsultoria = {
  cod: number
  nome: string
  status: number
  cpf_cnpj: string
  rg: null
  uf_rg: null
  nacionalidade: null
  tipo: null
  sexo: null
  nascimento: null
  cod_escolaridade: null
  cod_estado_civil: null
  cod_profissao: null
  endereco: string
  complemento: null
  cep: string
  cod_cidade: number
  fone: null
  fone2: null
  email: null
  razao_social: string
  linha2: string
  linha1: string
  logo: string
  create_time: string
  update_time: null
  delete_time: null
  ie: null
  logo_url: string
  cidade: [
    {
      cod: number
      codigo: number
      nome: string
      uf: string
      cod_uf: number
      status: number
      create_time: string
      update_time: null
      delete_time: null
      uf_nome: string
      uf_sigla: string
    }
  ]
}

interface Consultoria {
  itens: ItensConsultoria[]
  total: number
}

export const useGetConsultoria = (pagination = 15, page = 1, nome?: string) => {
  const queryKey: any = [`/conta`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<Consultoria, Error>(
    queryKey,
    async () => {
      return api
        .get(
          `/conta?codConta=&pagination=${pagination}&page=${page}&embed=aplicacoes&nomeGeral=${nome}`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de consultorias!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_consultoria: data,
    carregando_consultoria: isFetching,
    refetch_data_consultoria: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}

export const useGetConsultoriaEditar = (cod: number) => {
  const queryKey: any = [`/conta_${cod}`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<Consultoria, Error>(
    queryKey,
    async () => {
      return api
        .get(
          `/conta?codConta=${cod}`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de consultorias!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_consultoria_editar: data,
    carregando_consultoria_editar: isFetching,
    refetch_data_consultoria_editar: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}